<template>
  <div class="comp-select-input-wrap">
    <div class="select-input-wrap">
      <el-select 
        class="select-bg"
        v-model="select"
        @change="handleChange"
        :disabled="options.length==1"
        :class="{hide: options.length==1}"
        >
        <el-option
          v-for="(item, i) in options" :key="i"
          :label="item[labelKey] || item.label"
          :value="item[valueKey] || item.value">
        </el-option>
      </el-select>
      <el-input
        :placeholder="$t('tip.input') + optionsName"
        @clear="clear"
        clearable
        v-model="inputValue"
        :formatter="formatter"
        >
      </el-input>
      <div v-if="showSearch" @click="search" class="search-btn">{{ $t('crud.searchBtn') }}</div>
    </div>
    <!-- <el-button v-if="showEmpty" @click="clear" type="default" icon="delete">{{ $t('crud.emptyBtn') }}</el-button> -->
  </div>
</template>
<script>

export default {
  name: 'select-input',
  props: {
    options: {
      type: Array,
      default() {
        return [
        ]
      }
    },
    defaultValue: {
      type: String,
      default: ''
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
    showEmpty: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      select: '',
      inputValue: '',
      formatter: (val) => val,
      optionsName: '',
    }
  },
  created() {
    if (this.defaultValue) {
      this.select = this.defaultValue;
    }
    this.setInputFormatter();
  },
  methods: {
    handleChange() {
      this.inputValue = '';
      this.setInputFormatter();
    },
    setInputFormatter() {
      const current = this.options.find((item) => item.value === this.select) || {};
      const formatter = current.formatter;
      if (formatter) {
        this.formatter = formatter;
      } else {
        this.formatter = (val) => val;
      }
      this.optionsName = current.label;
    },
    search() {
      const current = this.options.find((item) => item.value === this.select) || {};
      const key = current.searchKey;
      const params = {}
      const value = this.inputValue.trim()
      if (value) {
        params[key] = value;
      }
      this.$emit('search', params, () => {});
    },
    clear() {
      this.inputValue = '';
      const params = {}
      this.$emit('search', params, () => {});
    }
  }
}
</script>
<style lang="scss">

</style>

